import styled, { css, keyframes } from "styled-components";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";

export const ContentContainer = styled.div`
  /* flex: 1; */
  width: 100%;
  display: flex;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
`;
export const ButtonText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  letter-spacing: -0.07px;
  cursor: ${(p) => (p.$click ? "pointer" : "default")};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
export const DownloadButton = styled.button`
  display: flex;
  height: 32px;
  padding: 0px 10px;

  justify-content: center;
  cursor: pointer;
  align-items: center;
  white-space: nowrap;

  border-radius: 10px;
  border: 0.5px solid #2877d9;
  background: #2877d9;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.75;
  }
  &:active {
    scale: 0.975;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  @media (max-width: 768px) {
    gap: 8px;
  }
`;
export const BigRow = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const BigRowMobile = styled.div`
  display: none;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background: #000;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  z-index: 10;
  @media (max-width: 768px) {
    display: flex;
  }
`;
export const DeleteButton = styled.button`
  display: flex;
  padding: 0px 10px;
  height: 32px;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #ff474a;
  background: #112238;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: #ff474a;
    }
  }
  &:hover {
    opacity: 0.75;
  }
  &:active {
    scale: 0.975;
  }
`;

export const CollectionButton = styled.button`
  display: flex;
  align-items: center;
  width: fit-content;
  justify-content: center;
  padding: 0px 10px;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#345884" : "#112238")};
  border-radius: 8px;
  border: 1px solid #345884;

  cursor: pointer;
  &:active {
    transform: scale(0.95);
  }

  transition: all 0.3s ease-in-out;
`;
export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;

  padding: 0 16px;
  flex: 1;
  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }

  @media (max-width: 480px) {
    justify-content: center;
  }
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
`;
export const CardTitle = styled.h3`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.12px;

  @media (max-width: 500px) {
    font-size: 20px;
  }
  @media (max-width: 375px) {
    font-size: 18px;
  }
`;
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-left: 10px;
  padding-top: 1px;
`;
export const CreatePlaylistCard = styled.div`
  border-radius: 24px;
  border: 1px solid var(--100, #4d9dff);
  background: linear-gradient(
    180deg,
    var(--300, #0f4e9e) 0%,
    var(--400, #072e61) 100%
  );

  display: flex;
  width: 100%;
  padding: 24px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  aspect-ratio: 1 / 1.5;

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  will-change: transform;
  backface-visibility: hidden;
  contain: layout style paint;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(40, 119, 217, 0.3);
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 1023px) {
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 599px) {
    padding: 16px;
    gap: 16px;
    border-radius: 16px;
  }

  @media (max-width: 500px) {
    svg {
      width: 80px;
      height: 80px;
    }
  }
  @media (max-width: 375px) {
    svg {
      width: 70px;
      height: 70px;
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 7px;
  padding: ${(p) => (p.$offHorizontalPadding ? 0 : "0 16px 0px 16px")};
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  flex-direction: row;
  align-items: center;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-top: 2px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  flex: 1;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const CloseIconWrapper = styled.div`
  height: 100%;
  width: 44px;
  transition: opacity 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;
export const CloseIcon = styled(CloseSvg)``;
export const CategoryText = styled.p`
  color: ${({ $selected }) => ($selected ? "#fff" : "#fff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  line-height: 18px;
  letter-spacing: -0.07px;
  white-space: nowrap;
`;

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#345884" : "#112238")};
  border-radius: 8px;
  border: 1px solid #345884;

  cursor: pointer;
  padding: ${(p) => (p.$noPadding ? "0px" : "0px 12px")};

  ${({ $animation }) =>
    $animation &&
    css`
      background: linear-gradient(
        90deg,
        #152a47 0px,
        #23406a 40px,
        #152a47 80px
      );
      background-size: 468px 100%;
      animation:
        ${shimmer} 3s infinite linear,
        ${pulse} 2s infinite ease-in-out;
    `}
`;

export const SearchFilter = styled.div`
  display: flex;
  height: 32px;
  padding: 0 8px 0 11px;
  align-items: center;
  border-radius: 8px;

  border: 1px solid #345884;
  background: #112238;

  cursor: ${(props) => (props.$expanded ? "default" : "pointer")};

  width: ${(props) => (props.$expanded ? "230px" : "44px")};
  transition:
    width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
    background 0.3s ease,
    opacity 0.3s ease;

  @media (max-width: 768px) {
    min-width: ${(props) => (props.$expanded ? "230px" : "44px")};
    transition:
      min-width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
      background 0.3s ease,
      opacity 0.3s ease;
  }

  @media (max-width: 480px) {
    width: ${(props) => (props.$expanded ? "230px" : "44px")};
  }
  position: relative;

  svg {
    min-height: 26px;
    min-width: 26px;
    max-height: 26px;
    max-width: 26px;
  }
  div {
    z-index: 10;
    left: ${(props) => (!props.$expanded ? "-2.5px" : "-2.5px")};
  }
`;

export const StyledInput = styled.input`
  background-color: blue;
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.07px;
  padding-left: 30px;
  z-index: 2;

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }
`;
